export const PROD = 'production';
export const UAT = 'uat';
export const UAT2 = 'uat2';
export const DEV = 'development';
export const DEV2 = 'development2';
export const LOCAL = 'local';